import { Text } from '@mantine/core'
import { CompassRose } from './CompassRose'
import classes from './MarinaLayout.module.css'

interface Props {
  collapsed?: boolean
}

/**
 * JP MARINE brand — compass rose mark (Pelabuhan design language).
 * Replaces the 3×3 grid pattern with a maritime navigational symbol.
 * Renders mark only when collapsed; wordmark uses Fraunces display font.
 */
export function MarinaBrand({ collapsed }: Props) {
  return (
    <div className={classes.brand}>
      <div className={classes.brandIcon}>
        <CompassRose size={28} color="white" stroke={1.5} />
      </div>
      {!collapsed && (
        <Text className={classes.brandText} style={{ fontFamily: 'var(--font-display)' }}>
          JP MARINE
        </Text>
      )}
    </div>
  )
}
